// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__3lx7d","detailsBorder":"styles_detailsBorder__2Ixx3"};